import {
  vs2jen2LimitedReleaseDetailConstants,
  createVs2jen2LimitedReleaseDetailConstants,
  editVs2jen2LimitedReleaseDetailConstants,
  activateVs2jen2LimitedReleaseDetailConstants,
  deactivateVs2jen2LimitedReleaseDetailConstants,
  deleteVs2jen2LimitedReleaseDetailConstants,
} from "../_redux-constants";
import { vs2jen2LimitedReleasesDetailService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getVs2jen2LimitedReleaseDetail(queryParams) {
  function getVs2jen2LimitedReleaseDetailLoad() {
    return {
      type: vs2jen2LimitedReleaseDetailConstants.VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function getVs2jen2LimitedReleaseDetailSuccess(data) {
    return {
      type: vs2jen2LimitedReleaseDetailConstants.VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function getVs2jen2LimitedReleaseDetailFailure(error) {
    return {
      type: vs2jen2LimitedReleaseDetailConstants.VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2jen2LimitedReleaseDetailLoad());
    return vs2jen2LimitedReleasesDetailService
      .getVs2jen2LimitedReleaseDetail(queryParams)
      .then(
        (data) => {
          dispatch(getVs2jen2LimitedReleaseDetailSuccess(data));
        },
        (error) => {
          dispatch(getVs2jen2LimitedReleaseDetailFailure(error?.toString()));
        }
      );
  };
}

function createVs2jen2LimitedReleaseDetail(requestBody, queryParams) {
  function createVs2jen2LimitedReleaseDetailLoad() {
    return {
      type: createVs2jen2LimitedReleaseDetailConstants.CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function createVs2jen2LimitedReleaseDetailSuccess(data) {
    return {
      type: createVs2jen2LimitedReleaseDetailConstants.CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function createVs2jen2LimitedReleaseDetailFailure(error) {
    return {
      type: createVs2jen2LimitedReleaseDetailConstants.CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createVs2jen2LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2jen2LimitedReleasesDetailService
        .createVs2jen2LimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createVs2jen2LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              createVs2jen2LimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editVs2jen2LimitedReleaseDetail(requestBody, queryParams) {
  function editVs2jen2LimitedReleaseDetailLoad() {
    return {
      type: editVs2jen2LimitedReleaseDetailConstants.EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function editVs2jen2LimitedReleaseDetailSuccess(data) {
    return {
      type: editVs2jen2LimitedReleaseDetailConstants.EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function editVs2jen2LimitedReleaseDetailFailure(error) {
    return {
      type: editVs2jen2LimitedReleaseDetailConstants.EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editVs2jen2LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2jen2LimitedReleasesDetailService
        .editVs2jen2LimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editVs2jen2LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editVs2jen2LimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateVs2jen2LimitedReleaseDetail(queryParams) {
  function activateVs2jen2LimitedReleaseDetailLoad() {
    return {
      type: activateVs2jen2LimitedReleaseDetailConstants.ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function activateVs2jen2LimitedReleaseDetailSuccess(data) {
    return {
      type: activateVs2jen2LimitedReleaseDetailConstants.ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function activateVs2jen2LimitedReleaseDetailFailure(error) {
    return {
      type: activateVs2jen2LimitedReleaseDetailConstants.ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateVs2jen2LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2jen2LimitedReleasesDetailService
        .activateVs2jen2LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(activateVs2jen2LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              activateVs2jen2LimitedReleaseDetailFailure(error?.toString())
            );
            reject(error);
          }
        );
    });
  };
}

function deactivateVs2jen2LimitedReleaseDetail(queryParams) {
  function deactivateVs2jen2LimitedReleaseDetailLoad() {
    return {
      type: deactivateVs2jen2LimitedReleaseDetailConstants.DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deactivateVs2jen2LimitedReleaseDetailSuccess(data) {
    return {
      type: deactivateVs2jen2LimitedReleaseDetailConstants.DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deactivateVs2jen2LimitedReleaseDetailFailure(error) {
    return {
      type: deactivateVs2jen2LimitedReleaseDetailConstants.DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateVs2jen2LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2jen2LimitedReleasesDetailService
        .deactivateVs2jen2LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deactivateVs2jen2LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateVs2jen2LimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteVs2jen2LimitedReleaseDetail(queryParams) {
  function deleteVs2jen2LimitedReleaseDetailLoad() {
    return {
      type: deleteVs2jen2LimitedReleaseDetailConstants.DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deleteVs2jen2LimitedReleaseDetailSuccess(data) {
    return {
      type: deleteVs2jen2LimitedReleaseDetailConstants.DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deleteVs2jen2LimitedReleaseDetailFailure(error) {
    return {
      type: deleteVs2jen2LimitedReleaseDetailConstants.DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteVs2jen2LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2jen2LimitedReleasesDetailService
        .deleteVs2jen2LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deleteVs2jen2LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deleteVs2jen2LimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const vs2jen2LimitedReleasesDetailActions = {
  getVs2jen2LimitedReleaseDetail,
  createVs2jen2LimitedReleaseDetail,
  editVs2jen2LimitedReleaseDetail,
  activateVs2jen2LimitedReleaseDetail,
  deactivateVs2jen2LimitedReleaseDetail,
  deleteVs2jen2LimitedReleaseDetail,
};
